import ListFields from '../fragments/ListFields';

export default (languageCode: string) => /* GraphQL */ `
    mutation RemoveDesigns($configurationIds: [ID!]!, $listId: ID) {
        list: removeDesigns(
            configurationIds: $configurationIds
            listId: $listId
            itemPresentation: { languageCode: "${languageCode}" }
        ) {
            ...ListFields
        }
    }
    ${ListFields}
`;
